import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const ErrorMessage = ({
  message,
  type = "error",
  onDismiss,
  className = "",
}) => {
  if (!message) return null;

  const typeClasses = {
    error: "error-message",
    warning: "warning-message",
    info: "info-message",
  };

  return (
    <div className={`${typeClasses[type]} ${className}`}>
      <div className="error-content">
        <FaExclamationTriangle className="error-icon" />
        <span className="error-text">{message}</span>
        {onDismiss && (
          <button
            className="error-dismiss"
            onClick={onDismiss}
            aria-label="סגור"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
